var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subpage"},[_c('MarkdownIt',{staticClass:"inner faqs",attrs:{"file":"faqs","scrollTo":"scrollTo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }